var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
export function withOwnProvider(component) {
  var Context = React.createContext(component); // note: this sets the default value to the component, biut it can be overridden

  var Component = function Component(props) {
    var Provided = React.useContext(Context);

    if (Provided) {
      if (Provided.hasOwnProperty('Default')) {
        // this prevents infinite recursion if a consumer provides a specialisation of this same component and bundled provider. 

        /* @ts-ignore */
        return React.createElement(Provided.Default, __assign({}, props));
      } else {
        return React.createElement(Provided, __assign({}, props));
      }
    }
  };

  return Object.assign(Component, {
    Provider: Context.Provider,
    Default: component
  });
}
;